import SharedSnippet from './components/SharedSnippet';
import type { EditorPlugin, PluginState } from '../../types/aha-editor';
import ToolEditSnippet from './tools/ToolEditSnippet';
import ToolDelete from '../../tools/ToolDelete';
import ToolInsertSpaceAbove from '../../tools/ToolInsertSpaceAbove';
import ToolInsertSpaceBelow from '../../tools/ToolInsertSpaceBelow';
import {
  SharedSnippetBlockSchemaPlugin,
  SharedSnippetInlineSchemaPlugin,
} from './SharedSnippetSchemaPlugin';

const BlockPlugin: EditorPlugin = {
  name: 'Shared Snippet block plugin',
  component: {
    type: 'shared-snippet',
    component: SharedSnippet,
    toolbarItems: [
      [ToolEditSnippet],
      [ToolInsertSpaceAbove, ToolInsertSpaceBelow],
      [ToolDelete],
    ],
  },
};

const InlinePlugin: EditorPlugin = {
  name: 'Shared Snippet inline plugin',
  component: {
    type: 'shared-snippet-inline',
    component: SharedSnippet,
    toolbarItems: [[ToolEditSnippet], [ToolDelete]],
  },
};

// We store the shared snippets in plugin state so that changes to the content
// will trigger a re-render of the shared snippet components.
const SharedSnippetCachePlugin: EditorPlugin = {
  name: 'Shared Snippet cache plugin',
  setPluginState: (pluginState: PluginState) => {
    // Initialize the cache of shared  snippets.
    pluginState.sharedSnippetCache = {};
  },
};

const SharedSnippetPlugin = [
  SharedSnippetCachePlugin,
  SharedSnippetBlockSchemaPlugin,
  SharedSnippetInlineSchemaPlugin,
  BlockPlugin,
  InlinePlugin,
];

export default SharedSnippetPlugin;
